var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rno-action-panel"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.addBar}}),_c('button',{staticClass:"register",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.preventDefault();return _vm.handleJump('/register')}}},[_vm._v(" 免费注册 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }